<template>
  <section id="easy-access-navbar" class="hidden-sm-and-down">
    <el-row type="flex" justify="center">
      <el-col :lg="24" :md="21" :sm="22" :xs="22">
        <ul class="menu-list">
          <li>
            <div class="sticy-logo">
              <router-link to="/" exact>
                <img src="/img/nutron-logo.png" alt="nutron-logo" class="img-fluid" />
              </router-link>
            </div>
          </li>
          <li v-for="category in categories" :key="category.id">
            <div v-if="category.parent_id === null && category.sub_categories.length">
              <el-dropdown class="nav-dropdown">
                <span class="el-dropdown-link">
                  {{ category.name }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="sub_category in category.sub_categories"
                    :key="sub_category.id"
                  >
                    <router-link
                      v-if="sub_category.products_count"
                      :to="'/products/'+ sub_category.slug"
                    >{{ sub_category.display_name }}</router-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <router-link
              v-if="category.products_count"
              :to="'/products/'+ category.slug"
            >{{ category.display_name }}</router-link>
          </li>
        </ul>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import { map } from 'lodash';
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      sticyHeading: false
    };
  },
  computed: {
    /**
     * List categories and sub categories.
     * @return {Array}
     */
    categories() {
      return map(this.getCategories, category => {
        category.is_visible = !!(category.products_count === 0 && category.sub_categories.length === 0 )
        return category
      }).filter(category => !category.is_visible)
    },
    ...mapGetters("categories", ["getCategories"])
  },
  methods: {
    async fetchCategories() {
      await this.$store.dispatch("categories/getCategories");
    },
    handleScroll() {
      // alert('This is How a Method Called');
      var headerTop = document.getElementById("easy-access-navbar");
      var sticky = 400;
      // Checking the offset;;
      if (window.pageYOffset > sticky) {
        headerTop.classList.add("sticky");
      } else {
        headerTop.classList.remove("sticky");
      }
    }
  },
  async created() {
    await this.fetchCategories();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.el-dropdown-menu {
  padding: 0;
}
.sticky {
  .menu-list {
    z-index: 3000;
  }
}
#easy-access-navbar {
  padding: 0 1em 1em 0;
  z-index: 12000;
  @media all and (max-width: 1194px){
    display: none!important;
  }

  .easy-access-heading {
    font-size: 1.875em;
    line-height: 2.125em;
    text-transform: uppercase;
    font-weight: normal;
    padding-bottom: 0;
  }

  .menu-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    li:not(:last-child) {
      a,
      span {
        margin-right: 0.625em;
        padding-right: 0.7em;
        border-right: 1px solid rgba(0, 0, 0, 0.2);
      }
    }

    li:first-child {
      a {
        border-right: none;
      }
    }
    li:last-child {
      a {
        border-right: none;
      }
    }

    li {
      a {
        color: #000;
        text-transform: uppercase;
        font-size: 0.95em;
        font-family: "Work Sans", sans-serif;
      }
      span {
        color: #000;
        text-transform: uppercase;
        font-size: 0.95em;
        font-family: "Work Sans", sans-serif;
      }

      p {
        color: #11233f;
        text-transform: uppercase;
        font-weight: 600;
        margin-right: 1.875em;
      }
    }
  }
}
.sticy-logo {
  display: none;
}
.sticky {
  padding: 5px 0 !important;
}
.sticky .easy-access-heading {
  display: none;
}
.sticky .sticy-logo {
  display: block;
  margin-right: 25px;
  text-transform: uppercase;
}
.sticky .menu-list li a {
  font-size: 0.9em !important;
}
.el-dropdown {
  font-size: inherit;
}
</style>
